import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { placesEnvironment } from '../places-environment';
import { placesPlaceSetSchema } from '../schemas/places-place-set.schema';

/**
 * Get a place set by its setId
 * @param setId Place set identifier
 * @returns Details of the place set
 */
export function getPlacesSetsSetId(this: unknown, setId: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        placesEnvironment.resolve(this).placeSetsSetIdUrl(String(setId)),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(placesPlaceSetSchema));
}
